import React from 'react';
import { motion } from 'framer-motion';
interface ProgressIndicatorProps {
  progress: number;
  label?: string;
}
export const ProgressIndicator = ({
  progress,
  label
}: ProgressIndicatorProps) => {
  return <div className="w-full" data-id="element-144">
      {label && <div className="flex items-center justify-between mb-2" data-id="element-145">
          <span className="text-xs font-semibold text-gray-600 dark:text-gray-400" data-id="element-146">
            {label}
          </span>
          <span className="text-xs font-bold text-[#7FE5A8]" data-id="element-147">{progress}%</span>
        </div>}
      <div className="h-2 bg-gray-200 dark:bg-[#1A2332] rounded-full overflow-hidden" data-id="element-148">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="h-full bg-gradient-to-r from-[#7FE5A8] to-[#5FD88F] rounded-full" data-id="element-149" />
      </div>
    </div>;
};